/**
 * Schemas for the v4_artifacts table.
 *
 * ArtifactDataSchema guards the `data` JSON column.
 * It is deliberately loose — artifact data is a free-form record whose shape
 * varies by artifact kind. The schema enforces only that the column is a
 * string-keyed object, not an array or primitive.
 */

import { z } from 'zod';

/**
 * Schema for v4_artifacts.data — a string-keyed record of unknown values.
 *
 * Use with parseDbJson:
 *   parseDbJson(ArtifactDataSchema, artifact.data, { column: 'v4_artifacts.data', rowId: artifact.uuid })
 */
export const ArtifactDataSchema = z.record(z.string(), z.unknown());

export type ArtifactData = z.infer<typeof ArtifactDataSchema>;
